import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react'

interface BudgetWarningContextValue {
  showWarning: boolean
  setSoftWarning: (active: boolean) => void
}

const BudgetWarningContext = createContext<BudgetWarningContextValue | null>(
  null,
)

export function BudgetWarningProvider({ children }: { children: ReactNode }) {
  const [showWarning, setShowWarning] = useState(false)

  const setSoftWarning = useCallback((active: boolean) => {
    setShowWarning(active)
  }, [])

  const value = useMemo(
    () => ({ showWarning, setSoftWarning }),
    [showWarning, setSoftWarning],
  )

  return (
    <BudgetWarningContext.Provider value={value}>
      {children}
    </BudgetWarningContext.Provider>
  )
}

export function useBudgetWarning() {
  const context = useContext(BudgetWarningContext)
  if (!context) {
    throw new Error('useBudgetWarning must be used within BudgetWarningProvider')
  }
  return context
}
